var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonQrScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #001213;\n      }\n\n      .st1 {\n        fill: #f1f1f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 0.3,
    y: 0.3,
    width: 87.4,
    height: 87.4,
    rx: 43.7,
    ry: 43.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Z6eLUl"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.8,34.9v5.5c0,1-.5,1.5-1.5,1.5h-10.9c-1,0-1.5-.5-1.5-1.5v-8.6c0-2.2,1.5-3.8,3.8-3.8h8.6c1,0,1.5.5,1.5,1.5v5.4h0ZM39.1,30.6c-.2,0-.3,0-.4,0h-7.1c-.7,0-1.1.4-1.1,1.1v7.4h8.5v-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.1,41.9h-5.5c-1,0-1.5-.5-1.5-1.5v-10.9c0-1,.5-1.5,1.6-1.5h8.7c2.1,0,3.7,1.6,3.7,3.7v8.8c0,1-.5,1.5-1.5,1.5h-5.5,0ZM56.4,39.1v-7.4c0-.8-.3-1.1-1.2-1.1h-7c-.1,0-.2,0-.4,0v8.5h8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.9,52.2v5.4c0,1.1-.5,1.6-1.6,1.6h-8.6c-2.2,0-3.8-1.5-3.8-3.8v-8.7c0-.9.5-1.5,1.5-1.5h11c.9,0,1.5.6,1.5,1.5v5.5h0ZM30.6,47.9v7.4c0,.8.3,1.1,1.1,1.1h7c.1,0,.2,0,.4,0v-8.5s-8.5,0-8.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.8,47.9v9.8c0,1-.9,1.7-1.8,1.4-.5-.2-.9-.7-.9-1.3,0-.6,0-1.2,0-1.8v-9.2c0-1.1.5-1.6,1.6-1.6h5.4c1.1,0,1.7,1,1.2,2-.3.5-.7.7-1.2.7h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.1,51.1v4.3c0,2.1-1.6,3.7-3.7,3.7h-3.2c-.9,0-1.5-.6-1.5-1.4s.6-1.3,1.4-1.3h3.1c.8,0,1.1-.3,1.1-1.1v-8.7c0-.6.2-1,.7-1.3.5-.2.9-.2,1.4,0,.4.3.6.7.6,1.2,0,1.5,0,3,0,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.8,65.9h-2.7c-.9,0-1.5-.5-1.5-1.3s.6-1.4,1.5-1.4h5.1c.7,0,1-.3,1-1v-5.1c0-.6.3-1.1.9-1.3.5-.2,1.1-.1,1.5.3.2.3.4.6.4.9,0,1.8,0,3.6,0,5.4,0,1.9-1.5,3.4-3.4,3.4-.9,0-1.8,0-2.7,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,27.2v-2.5c0-2,1.5-3.5,3.5-3.5h5.2c.9,0,1.5.5,1.5,1.4s-.6,1.4-1.5,1.4h-5c-.7,0-1,.2-1,1v5.1c0,.8-.6,1.4-1.3,1.4-.8,0-1.4-.5-1.4-1.3,0-.9,0-1.9,0-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,59.8v-2.7c0-.9.5-1.5,1.3-1.5.8,0,1.4.6,1.4,1.5v5c0,.7.3,1,1,1h5.1c.6,0,1.1.4,1.3,1,.2.5,0,1.2-.5,1.5-.2.2-.5.2-.8.2-1.8,0-3.6,0-5.5,0-1.8,0-3.3-1.5-3.4-3.4,0-.9,0-1.8,0-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.8,21.2h2.5c2,0,3.5,1.5,3.5,3.5v5.3c0,.6-.3,1.1-.9,1.3-.6.2-1.2,0-1.5-.5-.2-.3-.3-.6-.3-.9,0-1.7,0-3.4,0-5s-.3-1-1-1h-5.1c-.7,0-1.2-.3-1.3-.9-.2-.5,0-1.2.5-1.5.2-.2.6-.3.9-.3.9,0,1.8,0,2.8,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.6,52.2v1c0,.3-.2.5-.5.5h-2c-.3,0-.5-.2-.5-.5v-2c0-.4.2-.5.5-.5h1.9c.4,0,.5.2.5.5v1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.4,34.9v-1c0-.4.2-.5.5-.5h1.9c.4,0,.5.2.5.5,0,.7,0,1.3,0,2s-.2.5-.5.5h-1.9c-.4,0-.5-.2-.5-.6v-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.1,33.4h1c.3,0,.5.2.5.5v2c0,.3-.2.5-.5.5h-2c-.3,0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5h1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.9,50.6h1c.3,0,.5.2.5.5v2c0,.3-.2.5-.5.5h-2c-.3,0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5h1,0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonQrScan);
export default __webpack_public_path__ + "static/media/button_QR_scan.6c6092e28522ac088685be55d923b4c5.svg";
export { ForwardRef as ReactComponent };